import { render, staticRenderFns } from "./TimeAndPrioritiesManager.vue?vue&type=template&id=351fb677&"
import script from "./TimeAndPrioritiesManager.vue?vue&type=script&lang=js&"
export * from "./TimeAndPrioritiesManager.vue?vue&type=script&lang=js&"
import style0 from "./TimeAndPrioritiesManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports